import { useTranslation } from 'react-i18next';
import { CopyDataComponent } from './components/CopyDataComponent';
import { useCallback, useState } from 'react';
import { InfoModal } from './components/InfoModal';
import { InfoBlock } from './components/InfoBlock';
import { MESSAGE_STATUS, useMessageContext } from 'react-easyrocket';
import { SkeletonOfAnySize } from 'src/components/Skeletons';
import { CryptochillMethodsReturnType } from '../../types';

type CryptoBlockProps = Pick<
  CryptochillMethodsReturnType,
  'selectedCryptoMethod' | 'isLoadingCryptoMethods' | 'isFetchingMissingAddress'
>;

export const CryptoBlock = ({
  selectedCryptoMethod,
  isLoadingCryptoMethods,
  isFetchingMissingAddress
}: CryptoBlockProps) => {
  const { t } = useTranslation();
  const { openMessage } = useMessageContext();
  const [isInfoOpened, setIsInfoOpened] = useState(false);

  const copyFunc = useCallback(
    (value: string, textMessage: string) => {
      navigator.clipboard.writeText(value);
      openMessage?.(t(textMessage), MESSAGE_STATUS.SUCCESS);
    },
    [openMessage, t]
  );

  const walletTag = selectedCryptoMethod?.tag || '';
  const minAmountToDisplay = parseFloat(selectedCryptoMethod?.min_amount || '0');

  return (
    <>
      {isInfoOpened && (
        <InfoModal
          amountAndCurrency={
            selectedCryptoMethod ? `${minAmountToDisplay} ${selectedCryptoMethod?.name}` : ''
          }
          closePopup={() => {
            setIsInfoOpened(false);
          }}
        />
      )}
      <InfoBlock
        setIsInfoOpened={setIsInfoOpened}
        selectedCryptoMethod={selectedCryptoMethod}
        isFetchingMissingAddress={isFetchingMissingAddress}
      />

      {isLoadingCryptoMethods ? (
        <SkeletonOfAnySize className="h-[58px] min-h-[58px] rounded-xl mb-5" />
      ) : (
        <div className="flex gap-2 flex-wrap items-center self-stretch content-start mb-5">
          <CopyDataComponent
            isLoading={isFetchingMissingAddress}
            textMessage="depositCryptochill.paymentAddressCopy"
            title={t('depositCryptochill.paymentAddress')}
            value={selectedCryptoMethod?.account || ''}
            text={selectedCryptoMethod?.account || ''}
            copyFunc={copyFunc}
          />

          {selectedCryptoMethod?.tag && (
            <CopyDataComponent
              isLoading={isFetchingMissingAddress}
              textMessage="depositCryptochill.walletTagCopy"
              title={t('depositCryptochill.walletTag')}
              value={walletTag}
              text={walletTag}
              copyFunc={copyFunc}
            />
          )}
        </div>
      )}
    </>
  );
};
